import axios from 'axios';

const BASE_URL = 'https://back.kairaablockchainacademy.org';

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 30000
});

client.interceptors.response.use(
  res => res,
  err => {
    console.error('[API Error]', err.response?.status, err.response?.data || err.message);
    return Promise.reject(err);
  }
);

export const getBaseUrl = () => BASE_URL;

export default client;
